import { createStructuredSelector } from 'reselect';
import { isNotificationAccessError } from 'containers/ModalManager/selectors';
import { lastRefreshTime } from 'containers/Project/selectors';

export const assetsCollectionSelector = createStructuredSelector({
  isNotificationAccessError,
  lastRefreshTime,
});
